var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "25",
      "height": "24",
      "viewBox": "0 0 25 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#products_icon_192)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M24.3934 4.70605L24.3768 4.74902L24.4032 4.73828V19.2725L12.9032 23.8145L1.40515 19.2725V4.77246L1.4032 4.76758L1.40515 4.7666V4.73828L1.44226 4.75293L12.9081 0.185547L24.3934 4.70605ZM2.22644 18.71L6.02527 20.2197L8.1864 21.0381L12.493 22.79V10.0352L8.20105 8.33008L7.86609 8.19629V11.4463L7.4364 11.0166L7.1698 11.1094L6.86414 10.7842L6.54871 10.8584L6.32214 10.5449L5.98718 10.6387V7.44922L2.22644 5.95508V18.71ZM13.3143 10.0352V22.79L23.5819 18.71L23.5809 5.9541L13.3143 10.0352ZM8.70496 7.63965L12.9042 9.30957L23.3319 5.16504L19.0614 3.41113L8.70496 7.63965ZM2.57605 5.20508L6.17468 6.63379L16.7928 2.47949L12.8973 1.07422L2.57605 5.20508Z",
      "fill": _vm.color
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "products_icon_192"
    }
  }, [_c('rect', {
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white",
      "transform": "translate(0.903198)"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }